'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition() {
}
export { $c_Lapp_tulz_tuplez_Composition as $c_Lapp_tulz_tuplez_Composition };
$p = $c_Lapp_tulz_tuplez_Composition.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_tulz_tuplez_Composition;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition() {
}
export { $h_Lapp_tulz_tuplez_Composition as $h_Lapp_tulz_tuplez_Composition };
$h_Lapp_tulz_tuplez_Composition.prototype = $p;
//# sourceMappingURL=app.tulz.tuplez.-Composition.js.map
